export type Ok<T> = {
  readonly ok: true;
  readonly value: T;
};

export type Err<E> = {
  readonly ok: false;
  readonly err: E;
  readonly code?: string;
};

export type Result<T, E> = Ok<T> | Err<E>;

export const createOk = <T>(value: T): Ok<T> => ({
  ok: true,
  value,
});

export const createErr = <E>(err: E): Err<E> => ({
  ok: false,
  err,
});
